import { render, staticRenderFns } from "./viewPerson.vue?vue&type=template&id=cd812c48&"
import script from "./viewPerson.vue?vue&type=script&lang=js&"
export * from "./viewPerson.vue?vue&type=script&lang=js&"
import style0 from "./viewPerson.vue?vue&type=style&index=0&id=cd812c48&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports